export default __webpack_public_path__ + "static/media/usdt.004b5e55.svg";